export function PageTitle({ title }: { title: string }) {
  return <h1 className="text-[24px] font-bold text-primary">{title}</h1>;
}
